import { useQuery } from "@tanstack/react-query";
import { create, windowScheduler, indexedResolver } from "@yornaath/batshit";
import { Streams } from "@graylog/server-api";
const pipelines = create({
  fetcher: async (streamIds) => Streams.getConnectedPipelinesForStreams({ stream_ids: streamIds }),
  resolver: indexedResolver(),
  scheduler: windowScheduler(10)
});
const usePipelinesConnectedStream = (streamId, enabled = true) => {
  const { data, refetch, isInitialLoading, error, isError } = useQuery({
    queryKey: ["stream", "pipelines", streamId],
    queryFn: () => pipelines.fetch(streamId),
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data: data != null ? data : [],
    refetch,
    isInitialLoading,
    error,
    isError
  };
};
export default usePipelinesConnectedStream;
